import { useEffect, useState } from 'react';

export default function useCountUp(end, startAnimation, duration = 1500) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!startAnimation) return;
        const numericValue = Number(String(end).replace(/\D/g, ''));
        if (isNaN(numericValue)) return;
        let startTime;
        const animate = (time) => {
            if (!startTime) startTime = time;
            const progress = Math.min((time - startTime) / duration, 1);
            setCount(Math.floor(progress * numericValue));
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
            else {
                setCount(numericValue);
            }
        };
        requestAnimationFrame(animate);
    }, [end, startAnimation, duration]);

    return count;
}